import "./index.shared";
import "core-js/stable";
import {createRoot} from "react-dom/client";
import React, {StrictMode} from "react";
import {QueryClient, QueryClientProvider} from "react-query";
import {ReactQueryDevtools} from "react-query/devtools";
import {LocaleProvider} from "./localization/LocaleProvider";
import LocalizedShopifyProviderWithCart from "./LocalizedShopifyProviderWithCart";
import {CheckoutProvider} from "./checkoutV2/useCheckout";
import CheckoutManagementV2 from "./checkoutV2/CheckoutManagementV2";
import {SelectedTagHandlesProvider} from "./filter/SelectedTagHandlesProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});

const rootContainer = document.getElementById("react-meal-boxes-selection");

if (rootContainer) {
  const root = createRoot(rootContainer);
  root.render(
    <QueryClientProvider client={queryClient}>
      <StrictMode>
        <ReactQueryDevtools />
        <LocaleProvider>
          <LocalizedShopifyProviderWithCart>
            <SelectedTagHandlesProvider>
              <CheckoutProvider>
                <CheckoutManagementV2 />
              </CheckoutProvider>
            </SelectedTagHandlesProvider>
          </LocalizedShopifyProviderWithCart>
        </LocaleProvider>
      </StrictMode>
    </QueryClientProvider>,
  );
}
